import styled from "styled-components";

interface Props {
    points: number | undefined
}


const CurrentScore = ({ points }: Props) => {

    return (
        <Container className="font-list no-border">
            <ValueField className="font-list font-score">
                {points !== undefined ? points.toFixed(0) : ""}
            </ValueField>
        </Container>
    );
};


const Container = styled.div`
    border: 3px solid;
    border-radius: 5px;
`

const Title = styled.div`
    padding: .5em;
    margin: 0;
`

const ValueField = styled.div`
    font-size: 1.875em;
    border-top: 2px solid;
`


export default CurrentScore;